module.exports = __webpack_public_path__ + "static/moon-d4f7527440fa7d187dff4b46640afab6.png";